import { KnownProduct } from "../../Admin/Product/KnownProduct.tsx";
import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  HeyLightConfigDTO,
  StripeConfigDTO,
} from "../../NormasTeachingCheckout/PaymentMethodConfiguration.ts";
import { NormasTeachingProductDTO } from "./useNormasTeachingProductById.ts";
import { OneOnOneLessonType } from "../../Admin/NormasTeachingProduct/OneOnOneLessonType.tsx";

export type FPSProductInfo = Partial<{
  durationInWeeks: number;
  lessonsPerWeek: number;
  unlimitedLessonsPerWeek: boolean;
  totalLessons: number;
  extraWeek: boolean;
  warrantyMinAttendedLessons: number;
  warrantyEnabled: boolean;
  userGroupSlug: string;
  doNotEnroll: boolean;
  doNotMerge: boolean;
  oneOnOne: boolean;
  oneOnOneTotalLessons: number;
  oneOnOneDurationInWeeks: number;
  oneOnOneMaxCancellations: number;
  oneOnOneLessonType: OneOnOneLessonType;
}>;

export function useUpdateNormasTeachingProduct() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);
  const updateNormasTeachingProduct = async (
    normasTeachingProductId: string,
    normasTeachingProduct: {
      productName: string;
      variantProductName: string;
      priceInCents: {
        amount: number;
        currency: "EUR";
      };
      productClass: KnownProduct;
      purchaseAcTags: string[];
      refundAcTags: string[];
      bundledProductIds: string[];
      peopleCount: number;
      analyticsTag?: string;
      fpsProductInfo?: FPSProductInfo;
      stripeConfig?: StripeConfigDTO;
      heylightConfig?: HeyLightConfigDTO;
      productDescription?: string;
      isCouponEnabled?: boolean;
      oneOnOneTotalLessons?: number;
    },
  ): Promise<NormasTeachingProductDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingProductDTO>(
          `/products/update/${normasTeachingProductId}`,
          normasTeachingProduct,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateNormasTeachingProduct,
    loading,
  };
}
